<template>
  <div class="">
    <div class="head">
      <div class="headLogo" @click="$router.push('/')">
        <img class="headLogo_img" src="../../static/img/logo.png" alt="" />
      </div>
      <div class="ut">Mfo Eckz, Too</div>
    </div>

    <!-- 中间部分 -->
    <div class="minu">
      <div>
        <div class="minu_title">Войти в личный кабинет</div>
        <!-- 手机号 -->
        <div>
          <div :class="phoneShow ? 'minu_phone-c' : 'minu_phone'">
            <div class="minu_phone-num">+7</div>
            <input :class="phoneShow ? 'minu_phone-input-c' : 'minu_phone-input'" type="tel" @focus="onFocus('phone')" name="" maxlength="10" id="" v-model="phone" placeholder="номер телефона*" />
          </div>
          <div class="minu_phone-text" v-if="phoneShow">Обязательное поле</div>
        </div>
        <!-- 验证码 -->
        <div style="margin-bottom: 0.21rem;margin-top: 0.13rem;">
          <div v-if="optionFlag">
            <div :class="optionShow ? 'minu_option-c' : 'minu_option'">
              <input :class="optionShow ? 'minu_phone-input-c' : 'minu_phone-input'" type="tel" @focus="onFocus('code')" name="" maxlength="4" id="" v-model="option" placeholder="Проверочный код" />
              <div class="minu_option-num" v-if="!codeBtnShow">(Отправлено {{codeTime}})</div>
              <div class="minu_option-btn" @click="getcode" v-else>Повторно получить</div>
            </div>
            <div class="minu_phone-text" v-if="optionShow">Ошибка кода подтверждения, пожалуйста, введите еще раз</div>
          </div>
        </div>
        <div class="minu_btn" @click="getcode" v-if="!loginShow">продолжать</div>
        <div class="minu_btn" @click="loginFn" v-else>продолжать</div>
        <div class="minu_ag">
          <span>Я ознакомлен с </span>
          <span style="color: #4C9F70;text-decoration: underline;cursor: pointer;" @click="privacyFn">Политика конфиденциальности</span>
          <span style="color: #4C9F70;text-decoration: underline;cursor: pointer;" @click="contractFn">Договор на предоставление микрокредита</span>
          <span style="color: #4C9F70;text-decoration: underline;cursor: pointer;" @click="BasicRulesFn">Правила предоставления микрокредита</span>
        </div>
      </div>
    </div>

    <!-- 底部协议 -->
    <div class="bom">
      <div class="bom_con">
        <div class="bom_con-text">Адрес:Казахстан, город Алматы, Бостандыкский район,улица Абиш Кекилбайулы, дом 34, офис</div>
        <div class="bom_minuIm">
          <div class="bom_con-num">Скачивай мобильное приложение через:</div>
          <div class="bom_minuIm">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt=""
              @click="googleFn" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt="" @click="appstoreFn" />
          </div>
        </div>
      </div>
      <div class="bom_mi">
        <div class="bom_mi-text">Понедельник-пятница 9:00 - 21:00 Суббота-воскресенье 11:00 - 21:00</div>
        <div class="bom_mi-tit">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М,
          от 12.09.2024 года, выдана Управлением региональных представителей в городе Алматы Агентства Республики
          Казахстан по регулированию и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    sendCode,
    login,
    userStepData
  } from '@/api/info'
  export default {
    name: "login",
    data() {
      return {
        index: 2,
        phone: '',
        phoneShow: false,
        option:'',
        optionShow: false,
        optionFlag: false,
        codeTime: 60,
        timeShow: '',
        countDownFlag: true,
        flag: false,//防止重复点击
        loginShow: false,//是否显示登录按钮
        codeBtnShow: false,//是否显示重发验证码的按钮
      };
    },
    methods: {
      goFn(type) {
        this.index = type
        if (type == 1) {
          this.$router.push('/about')
        } else {
          this.$router.push('/tutorial')
        }
      },
      getcode(){
        if(this.phone.length == 0){
          this.phoneShow = true
          this.$message.error({
            message: 'Номер телефона не может быть пустым!'
          });
          return
        }
        if(this.phone.length != 10){
          this.phoneShow = true
          this.$message.error({
            message: 'Пожалуйста, введите свой полный номер мобильного телефона!'
          });
          return
        }
        if(this.flag) return
        this.flag = true
        var parameter = {
          phone: '7' + this.phone
        }
        sendCode(parameter).then(res => {
          if(res.data.status != 0){
            this.flag = false
            this.$message.error({
              message: res.data.remark || 'Не удалось отправить код подтверждения'
            });
          }else{
            this.optionFlag = true
            this.flag = false
            this.loginShow = true
            this.codeTime = 60;
            clearTimeout(this.timeShow);
            this.timeShow = ''
            this.Countdown()
          }
        })
      },
      loginFn(){
        if(this.phone.length == 0){
          this.phoneShow = true
          this.$message.error({
            message: 'Номер телефона не может быть пустым!'
          });
          return
        }
        if(this.phone.length != 10){
          this.phoneShow = true
          this.$message.error({
            message: 'Пожалуйста, введите свой полный номер мобильного телефона!'
          });
          return
        }
        if(this.option.length == 0){
          this.optionShow = true
          this.$message.error({
            message: 'Номер телефона не может быть пустым!'
          });
          return
        }
        if(this.option.length != 4){
          this.optionShow = true
          this.$message.error({
            message: 'Пожалуйста, введите свой полный номер мобильного телефона!'
          });
          return
        }
        if(this.flag) return
        this.flag = true
        var parameter = {
          phone: '7' + this.phone,
          code: this.option
        }
        login(parameter).then(res => {
          if(res.data.status != 0){
            this.flag = false
            this.$message.error({
              message: res.data.remark || 'Ошибка кода подтверждения'
            });
          }else{
            this.flag = false
            localStorage.setItem('token',res.data.element.token)
            localStorage.setItem('phone',this.phone)
            userStepData().then(res => {
              var step = res.data.element.step
              if(step >= 12){
                this.$router.push('/underreview')
              }else{
                this.$router.push('/personal')
              }
            })
          }
        })
      },
      // 获取焦点
      onFocus(e){
        if(e == 'phone'){
          this.phoneShow = false
        }
        if(e == 'code'){
          this.optionShow = false
        }
      },
      homeFn(index) {
        if (index == 0) {
          document.querySelector("#jump" + index).scrollIntoView(true);
        }
      },
      // 倒计时
      Countdown(){
        this.timeShow = setTimeout(() => {
          let that = this
        	this.codeTime--;
        	if (this.codeTime <= 0) {
        		this.codeTime = 60;
            this.codeBtnShow = true
            this.countDownFlag = false
        	}
        	that.Countdown();
        }, 1000);
        if (!this.countDownFlag) {
        	this.codeTime = 60;
            this.codeBtnShow = true
        	clearTimeout(this.timeShow);
        	this.countDownFlag = true
        }
      },
      googleFn() {
        location.href =
          'https://play.google.com/store/apps/details?id=express.credit.fast.tez.loan.money.cash.pay.bank.card'
      },
      privacyFn() {
        location.href = 'https://mfoeckz.com/privacy.html'
      },
      BasicRulesFn() {
        location.href = 'https://mfoeckz.com/BasicRules.pdf'
      },
      contractFn() {
        location.href = 'https://mfoeckz.com/contract.pdf'
      },
      appstoreFn() {
        location.href = 'https://apps.apple.com/kz/app/%D0%B1%D1%8B%D1%81%D1%82%D1%80%D1%8B%D0%B9-%D0%B7%D0%B0%D0%B9%D0%BC/id6751275518'
      }
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
    border: none;
    Outline: none;
  }

  .head {
    padding: 0.1rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headLogo_img {
    width: 0.27rem;
    height: 0.27rem;
    cursor: pointer;
  }

  .headLogo_title {
    width: 0.41rem;
    height: 0.19rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.08rem;
    color: #0aba08;
    font-style: normal;
  }

  .ut{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
  }

  .minu {
    border-top: 0.01rem solid #C0C0C0;
    padding-top: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2.18rem;
  }

  .minu_title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.17rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.31rem;
  }

  .minu_phone {
    width: 2.75rem;
    background: #FFFFFF;
    border-radius: 0.04rem;
    border: 0.01rem solid #E0DFDF;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.05rem 0 0.05rem 0.05rem;
    margin-bottom: 0.03rem;
  }

  .minu_phone-c {
    width: 2.75rem;
    background: #FFFFFF;
    border-radius: 0.04rem;
    border: 0.01rem solid #FD4B4B;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.05rem 0 0.05rem 0.05rem;
    margin-bottom: 0.03rem;
  }

  .minu_phone-num {
    width: 0.19rem;
    height: 0.16rem;
    line-height: 0.16rem;
    background: #F4F5F5;
    border-radius: 0.03rem;
    text-align: center;
    margin-right: 0.05rem;
  }
  .minu_phone-input{
    flex: 1;
    font-family: SFProText, SFProText;
    font-weight: 500;
    font-size: 0.08rem;
    color: #333333;
    font-style: normal;
  }
  .minu_phone-text{
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.08rem;
    color: #FD4B4B;
    font-style: normal;
    margin-left: 0.1rem;
  }
  .minu_phone-input-c::placeholder{
    color: #FD4B4B;
  }
  .minu_option{
    width: 2.65rem;
    height: 0.26rem;
    background: #FFFFFF;
    border-radius: 0.04rem;
    border: 0.01rem solid #E0DFDF;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 0.08rem;
    margin-bottom: 0.03rem;
  }
  .minu_option-c{
    width: 2.65rem;
    height: 0.26rem;
    background: #FFFFFF;
    border-radius: 0.04rem;
    border: 0.01rem solid #FD4B4B;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.08rem;
    margin-bottom: 0.03rem;
  }
  .minu_option-num{
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.07rem;
    color: #AFAFAF;
    font-style: normal;
  }
  .minu_option-btn{
    width: 0.45rem;
    padding: 0.02rem 0;
    background: #D4AF37;
    border-radius: 0.03rem;
    text-align: center;
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.07rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }
  .minu_btn {
    width: 2.81rem;
    height: 0.29rem;
    line-height: 0.29rem;
    text-align: center;
    background: #D4AF37;
    border-radius: 0.15rem;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.1rem;
    color: #FFFFFF;
    font-style: normal;
    margin-bottom: 0.15rem;
    cursor: pointer;
  }

  .minu_ag {
    width: 2.82rem;
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.07rem;
    color: #333333;
    font-style: normal;
  }

  .bom {
    background: #F9F9F9;
    padding: 0.52rem 1.88rem;
  }

  .bom_con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.31rem;
  }

  .bom_con-text {
    width: 2.76rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
  }

  .bom_minuIm {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bom_con-num {
    width: 1.1rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.15rem;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
  }
  .bom_mi{
    display: flex;
    flex-direction: row;
  }
  .bom_mi-text{
    width: 1.78rem;
    height: 0.31rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.16rem;
    font-style: normal;
    margin-right: 0.4rem;
  }
  .bom_mi-tit{
    width: 4rem;
    height: 0.38rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue